module.exports = __webpack_public_path__ + "img/process.ecb8d275.png";